export default __webpack_public_path__ + "static/media/contactsInTabDark.c02a9ae3.svg";